export default __webpack_public_path__ + "static/media/contactSupport.a58045fc.svg";